import { useMemo } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface Props extends BoxProps {
    text?: string;
    letterSpacing?: string;
}

const LoaderWithText = ({ text = 'LOADING', letterSpacing = '0.15em', ...props }: Props) => {
    const circularProgressBackgroundStyles = useMemo(() => ({ color: 'rgba(0,0,0,0.1)' }), []);
    const circularProgressStyles = useMemo(() => ({ position: 'absolute', left: 0 }), []);
    const loadingTextStyles = useMemo(
        () => ({ fontSize: 10, letterSpacing, fontWeight: 700, mt: 1 }),
        [letterSpacing]
    );

    return (
        <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            {...props}
        >
            <Box sx={{ position: 'relative' }}>
                <CircularProgress size={24} variant="determinate" value={100} sx={circularProgressBackgroundStyles} />
                <CircularProgress size={24} disableShrink color="primary" sx={circularProgressStyles} />
            </Box>
            <Typography color="primary" sx={loadingTextStyles}>
                {text}
            </Typography>
        </Box>
    );
};

export default LoaderWithText;
